<template>
  <div>
    {{ descriptiveLevel }}
  </div>
</template>

<script>
const mapLevelToTranslation = {
  1: 'ADVERTISEMENT.KEYWORDPLANNER.COMPETITION_LOW',
  2: 'ADVERTISEMENT.KEYWORDPLANNER.COMPETITION_MEDIUM',
  3: 'ADVERTISEMENT.KEYWORDPLANNER.COMPETITION_HIGH',
};
function transformLevelToSentence(level) {
  if (level in mapLevelToTranslation) return mapLevelToTranslation[level];
  return 'UNKNOWN';
}

export default {
  name: 'KeywordPlannerCompetitionColumn',
  props: {
    row: {
      type: Object,
      required: true,
    },
  },
  computed: {
    descriptiveLevel() {
      return this.$t(transformLevelToSentence(this.row.competitionLevel));
    },
  },
};
</script>
